<template>
  <div class="membres" :class="{ marginBandeau: $store.state.bandeau }">
    <LigneTitre
      ><h2>Membres</h2>
      <template v-slot:reload>
        <img class="rotate" src="/assets/icons/rotate.jpg" title="Actualiser" @click="refresh" />
      </template>
    </LigneTitre>
    <ListeMembres ref="liste" :pattern="pattern" :save="false" />
  </div>
</template>

<script>
import ListeMembres from "@/components/membres/ListeMembres.vue";
import BaseMembres from "@/components/membres/BaseMembres.vue";
import LigneTitre from "@/components/membres/LigneTitre.vue";

export default {
  name: "Membres",
  components: { ListeMembres, LigneTitre },
  extends: BaseMembres,
  methods: {
    initPattern: function() {
      this.baseInitPattern();
    },

    refresh: async function() {
      this.$store.commit("setLoading", true);
      await this.init();
      this.$store.commit("setLoading", false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/base_membres.scss";

.rotate {
  width: 25px;
  right: 5px;
  cursor: pointer;
  filter: grayscale(100%);
  opacity: 0.8;
}
</style>
